console.log 'hello there!'